import './style.css';

export const Typing = ({ className }: { className?: string } = { className: '' }) => (
  <div className={`typing ${className}`}>
    <div className="typing__dot" />
    <div className="typing__dot" />
    <div className="typing__dot" />
  </div>
);
